import classNames from "classnames";

import {AnalyzerReportRowProps} from "@/pages/analyzer/Analyzer.types.ts";
import {getReportTag} from "@/pages/analyzer/Analyzer.utils.ts";
import {AnalyzerReportTag} from "@/pages/analyzer/components/AnalyzerReportTag.tsx";

import styles from "./AnalyzerReportRow.module.scss";

export const AnalyzerReportRow = ({row, separated}: AnalyzerReportRowProps) => {
  const {label, value, secondary} = row;
  const tag = getReportTag(row);

  return (
    <div className={classNames(styles.row, {[styles.separated]: separated})}>
      <div className={styles.label}>{label}</div>
      <div className={styles.values}>
        <span>{value}</span>
        {secondary && <span className={styles.secondary}>{secondary}</span>}
      </div>
      {tag && <AnalyzerReportTag tag={tag} className={styles.chip} />}
    </div>
  );
};
